import React, { Component } from "react";
import { Table, Button, Row, Col } from "reactstrap";

// UI Components
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import { getMessage } from "CONFIG/i18n";

import { getBootstrapTableOptions } from "UTILS/Utility";

import "../../SuperAdmin/Users/AdminDashboard.less";
import "../../SuperAdmin/Users/ReportComponent/SessionList.less";
import "./BulkImportUserErrorTable.less"
import "../Organisations/Organisations.less"

export default class BulkImportUserErrorTable extends Component {

  render() {
    return (
      <div className="errorsTableContainer">
    
        <BootstrapTable 
          data={this.props.errorRecordList}
          tableHeaderClass="errorsTableHeader"
          tableBodyClass='errorsTableBody'
          containerClass=''
          tableContainerClass=''
          headerContainerClass=''
          bodyContainerClass=''
          bordered={false}
          options={getBootstrapTableOptions()}
          // maxHeight= "7em"
          maxWidth="1em"
          printable
        >
          <TableHeaderColumn 
            dataField='email'   
            isKey={true}
            width="20"
            dataFormat={(cell, row) => {
              return (
                <label className="errorLabel mb-0 nameEllipsis" title={row.email}>
                  {row.email}
                </label>)
            }}>
            {getMessage("ACCOUNT_ID")}
          </TableHeaderColumn>
          <TableHeaderColumn 
            dataField='error'  
            className="nameEllipsis"
            width="60"
            dataFormat={(cell, row) => {
              return (
                <label className="errorLabel mb-0" title={getMessage(row.error.code)}>
                  {getMessage(row.error.code)}
                </label>)
            }}>
            {getMessage("Error")}
          </TableHeaderColumn>
        </BootstrapTable>
      </div>    
    );
  }
}
